import { ReturnPurposeEnum, ShiftEnum } from "../enums";

export class NeedleReturnProductionSharedDto {
    id: number;
    jobId: string;
    returnQty: string;
    returnTo: string;
    returnBy: string;
    returnPurpose: ReturnPurposeEnum;
    shifts: ShiftEnum;
    dateOfReturn: string;
    noOfPieces: string;
    remainingQty: string;
    createdUser: string;
    isActive?: boolean
    versionFlag?: number;
    updatedUser?: string;
    updatedAt?: Date;

    constructor(
        id: number,
        jobId: string,
        returnQty: string,
        returnTo: string,
        returnBy: string,
        remainingQty: string,
        returnPurpose: ReturnPurposeEnum,
        shifts: ShiftEnum,
        dateOfReturn: string,
        noOfPieces: string,
        createdUser: string,
        isActive?: boolean,
        versionFlag?: number,
        updatedUser?: string,
        updatedAt?: Date
    ) {
        this.id = id;
        this.jobId = jobId;
        this.returnQty = returnQty;
        this.returnTo = returnTo;
        this.returnBy = returnBy;
        this.remainingQty = remainingQty;
        this.returnPurpose = returnPurpose;
        this.shifts = shifts;
        this.createdUser = createdUser;
        this.isActive = isActive;
        this.versionFlag = versionFlag;
        this.updatedUser = updatedUser;
        this.updatedAt = updatedAt;
        this.dateOfReturn =dateOfReturn   
         this.noOfPieces = noOfPieces;

    }
}

export class NeedleReturnId {
    jobId: string;
}

